// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

/**
 * Remove tags from string
 */
const stripTags = (str: string): string => {
    const sanitized = str.split(String.fromCharCode(0)).join('');
    return sanitized.replace(/<\w+([\s/]+("[^"]*"|'[^']*'|[^>'"])+)?\s*("[^">]*|'[^'>])?(\/)?>|<\/\w+\s*>/gi, '');
};

export default stripTags;
